<template>
<div class="row">
	<div class="col-12">
		<legend class="col-form-label pt-0">
			{{ $t('item.seller') }} *
			<span v-if="activePerson">

				<b-button-group size="sm">
					<b-button target="_blank"
							  :to="{ name: 'personEdit', params: { personId: activePerson.id } }"
							  variant="outline-primary"
							  v-b-tooltip.hover
					          :title="$t('common.editPerson', { name: activePerson.full_name })">
						<fa-icon icon="edit"></fa-icon>
					</b-button>

					<b-button variant="outline-primary"
							  target="_blank"
							  :to="{ name: 'auctionSeller', params: { personId: activePerson.id } }"
							  v-b-tooltip.hover
					          :title="$t('auction.activityOf', { name: activePerson.full_name })">
						<fa-icon icon="user"></fa-icon>
					</b-button>
				</b-button-group>

			</span>
		</legend>
	</div>

	<div class="col-10">
		<autocomplete-person :selected="selectedPerson"
		                     :label="null"
		                     :deletable="false"
		                     :allow-empty="false"
		                     @update:person="changeSellerModal">
		</autocomplete-person>
	</div>

	<div class="col-2">
		<b-button block
		          variant="outline-primary"
		          v-b-tooltip.hover
		          :title="$t('person.add')"
		          @click="showModal">
			<fa-icon icon="plus"></fa-icon>
		</b-button>
	</div>

	<base-dialog-modal :title="$t('person.add')"
	                   ref="personDialogModal">
		<div slot="modal-body">

			<b-alert v-if="formError"
			         show
			         variant="warning">
				<span v-for="errors in formError.errors">
					<span v-for="error in errors">{{ error }}<br /></span>
				</span>
			</b-alert>

			<person-form-fields :form.sync="form"></person-form-fields>
		</div>

		<div slot="modal-footer">
			<div class="row">
				<div class="col">
					<b-button class="mt-3"
					          type="button"
					          variant="outline-primary"
					          block
					          @click="closeModal">

						{{ $t('common.cancel') }}

					</b-button>
				</div>
				<div class="col">
					<b-button class="mt-3"
					          type="button"
					          block
					          variant="outline-success"
					          @click="submitForm">
						<loader-spinner :text="$t('common.create')"
						                :show-spinner="isFetching"></loader-spinner>
					</b-button>
				</div>
			</div>
		</div>
	</base-dialog-modal>

	<base-dialog-modal ref="changeSellerModal"
	                   :hide-header-close="true"
	                   :no-close-on-backdrop="true"
	                   :no-close-on-esc="true"
	                   :title="$t('item.changeSeller')">

		<div slot="modal-body">
			<div class="row">
				<div class="col">
					{{ $t('item.changeSellerModal', { sellerName: modals.seller.title }) }}
				</div>
			</div>
		</div>
		<div slot="modal-footer">
			<div class="row">
				<div class="col">
					<b-button class="mt-3"
					          type="button"
					          variant="outline-primary"
					          block
					          @click="cancelSellerModal">{{ $t('common.cancel') }}</b-button>
				</div>
				<div class="col">
					<b-button class="mt-3"
					          type="button"
					          v-bind:disabled="modals.seller.loading"
					          block
					          variant="outline-danger"
					          @click="personIsUpdated(modals.seller.selected)">

						<loader-spinner :text="$t('item.changeSeller')"
						                :show-spinner="modals.seller.loading"></loader-spinner>

					</b-button>
				</div>
			</div>
		</div>
	</base-dialog-modal>
</div>
</template>
<script>
import { isNil } from 'lodash';
import BaseDialogModal from '@/components/elements/Base/BaseDialogModal';
import AutocompletePerson from '@/components/elements/AutocompletePerson';
import PersonFormFields from '@/components/views/Person/Form/PersonFormFields';
import PersonService from '@/services/person-service';
import LoaderSpinner from '@/components/elements/LoaderSpinner';
import { flashSuccess } from '@/helpers/flash-message-helper';
import { replaceEmptyByNull } from '@/helpers/object-helper';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers('item');

export default {
	name: 'seller-field',
	components: {
		AutocompletePerson,
		BaseDialogModal,
		PersonFormFields,
		LoaderSpinner
	},
	data: () => ({
		form: {},
		isFetching: false,
		formError: null,
		createdPerson: null,
		activePerson: false,
		modals: {
			seller: {
				loading: false,
				previous: null,
				selected: null,
				title: null
			}
		}
	}),
	props: {
		mode: {
			type: String,
			default: 'add'
		},
	},
	computed: {
		...mapGetters([
			'item',
			'lastCreatedItem'
		]),
		selectedPerson() {
			const selectedPerson = this.createdPerson || this.item.seller;
			this.activePerson = selectedPerson;

			return selectedPerson;
		}
	},
	watch: {
	},
	methods: {
		/**
		 * Trigger the seller change modal
		 * @param  {object} seller
		 * @return {boolean} false
		 */
		changeSellerModal(seller) {
			if (!isNil(seller)) {
				if (this.mode == 'edit') {
					this.modals.seller.previous = this.selectedPerson;
					this.createdPerson = seller;
					this.modals.seller.selected = seller;
					this.modals.seller.title = seller.full_name;
					this.$refs.changeSellerModal.show();
				} else {
					this.personIsUpdated(seller);
				}
			}
		},
		/**
		 * Cancel the seller change modal
		 */
		cancelSellerModal() {
			this.createdPerson = this.modals.seller.previous;
			this.form.seller_id = this.modals.seller.previous.id;
			this.closeSellerModal();
		},

		closeSellerModal() {
			this.$refs.changeSellerModal.hide();
		},

		/**
		 * Show modal
		 */
		showModal() {
			this.$refs.personDialogModal.show();
		},

		/**
		 * Close modal
		 */
		closeModal() {
			this.$refs.personDialogModal.hide();
		},

		/**
		 * Person is updated
		 * @param  {Object} person Selected person
		 */
		personIsUpdated(person) {
			this.activePerson = person;
			this.$emit('update:person', person);
			this.$refs.changeSellerModal.hide();
		},

		/**
		 * Reset form
		 */
		resetForm() {
			this.form = {};
			this.formError = null;
			this.createdPerson = null;

			this.setLastCreatedSeller();
		},

		/**
		 * Set
		 */
		setLastCreatedSeller() {
			if (this.mode == 'add' && this.lastCreatedItem) {
				this.createdPerson = this.lastCreatedItem.seller;
				this.$emit('update:person', this.createdPerson);
			}
		},

		/**
		 * Submit the form and select the person in the autocomplete
		 * @return {Promise} returns a promise with the person data
		 */
		submitForm() {
			const person = replaceEmptyByNull(this.form);

			if (person.code == null) {
				this.formError = {
					errors: {
						code: [
							this.$t('person.codeFieldRequiredError')
						]
					}
				};

				return Promise.reject();
			}

			this.isFetching = true;

			return PersonService.create(person).then(response => {

				this.isFetching = false;
				this.resetForm();
				this.closeModal();
				this.createdPerson = response.person;
				this.personIsUpdated(this.createdPerson);

				flashSuccess(this.$t('person.createSuccess'));

			}).catch(error => {

				this.isFetching = false;
				this.formError = error.response.data;

			});
		},	
	},
	mounted() {
		this.resetForm();
	}
}
</script>
<style lang="scss" scoped>
.badge {
    &-info {
        a {
            color: #fff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// SellerField.vue?16ae8900